"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var SCRIPT_BODY_TEMPLATE = "(function (w,d,s,o,f,js,fjs) {\n  w['ecm-widget']=o;w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };\n  js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];\n  js.id = '{{jsId}}'; js.dataset.a = '{{jsDataset}}'; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);\n}(window, document, 'script', 'ecmwidget', 'https://d70shl7vidtft.cloudfront.net/widget.js'));";
var EcoMail = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, renderEmpty = _a.renderEmpty;
    var _c = data.jsId, jsId = _c === void 0 ? '' : _c, _d = data.jsDataset, jsDataset = _d === void 0 ? '' : _d;
    react_1["default"].useEffect(function () {
        if (!jsId || !jsDataset) {
            return;
        }
        var scriptElementId = "ecomail-" + jsId;
        // ak sa meni widget v editore, musime zabezpecit ze sa po zmene udajov
        // znovu prerenderuje aj <script>
        if (document.querySelector(".ql-editor")) {
            var scriptElement = document.querySelector("#" + scriptElementId);
            scriptElement === null || scriptElement === void 0 ? void 0 : scriptElement.remove();
        }
        if (!document.querySelector("#" + scriptElementId)) {
            var newScript = document.createElement('script');
            newScript.id = scriptElementId;
            newScript.innerText = SCRIPT_BODY_TEMPLATE.replace('{{jsId}}', jsId).replace('{{jsDataset}}', jsDataset);
            document.body.appendChild(newScript);
        }
        return function () {
            var scriptElement = document.querySelector("#" + scriptElementId);
            scriptElement === null || scriptElement === void 0 ? void 0 : scriptElement.remove();
        };
    }, [jsId, jsDataset]);
    if (!(jsId && jsDataset) && renderEmpty) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty('ecomail'));
    }
    return react_1["default"].createElement("div", { key: "f-" + data.jsId, id: "f-" + data.jsId });
};
exports["default"] = react_1["default"].memo(EcoMail);
